import { getAggregatedFormValues } from '../../utils/getAggregatedFormValues';
import type { ReservationFormMainContext } from '../reservationFormMain.types';

import { canSaveAsDraftFromFormValues } from './canSaveAsDraftFromFormValues';

/** True when every trip leg has the following:
 * - purpose,
 * - appointment,
 * - pickup time (or will-call),
 * - addresses,
 * - AttributeLevel1,
 * - MobilityAttribute.
 */
export function canSaveAsDraftFromContext(
  context: ReservationFormMainContext,
): boolean {
  return canSaveAsDraftFromFormValues(getAggregatedFormValues(context));
}
